/**
 * Pure geometry for the studio's touch selection (mobile multi-select).
 * Kept fabric-free so the hit test can be unit-tested: callers turn a
 * canvas object's transform matrix into its four absolute corners and
 * ask whether a tap point falls inside.
 */

export interface Pt {
    x: number;
    y: number;
}

/**
 * Point-in-convex-quad test. Corners must be ordered (either
 * winding); points on an edge count as inside. Used to find which
 * member of a fabric ActiveSelection a tap landed on, and to hit-test
 * canvas objects from a raw pointer position before fabric's own
 * selection handling runs.
 */
export function pointInQuad(point: Pt, corners: Pt[]): boolean {
    if (!corners || corners.length !== 4) return false;
    let sign = 0;
    for (let i = 0; i < 4; i++) {
        const a = corners[i];
        const b = corners[(i + 1) % 4];
        const cross = (b.x - a.x) * (point.y - a.y) - (b.y - a.y) * (point.x - a.x);
        if (cross !== 0) {
            const s = cross > 0 ? 1 : -1;
            if (sign === 0) sign = s;
            else if (s !== sign) return false;
        }
    }
    return true;
}
